export default __webpack_public_path__ + "static/media/nlp.566b11c9.png";